import {
  startListening,
  appSync,
  isAnyOf,
  depositApproved,
  selectAuthenticationStatus,
} from '@betty/toolkit/state';
import { fetchPromos, getPromos } from './promos.slice';

startListening({
  actionCreator: getPromos,
  effect: (_, { getState, dispatch }) => {
    const authenticationStatus = selectAuthenticationStatus(getState());

    dispatch(fetchPromos(authenticationStatus));
  },
});

startListening({
  matcher: isAnyOf(appSync, depositApproved),
  effect: (_, { dispatch }) => {
    dispatch(getPromos());
  },
});
